import { NodeModel } from "@minoru/react-dnd-treeview";
import { Badge } from "@mui/material";
import { FC } from "react";
import { FileProperties } from "../../../../models/tree/FileProperties";
import { TypeIcon } from "../TypeIcon";

type Props = {
	dragSources: NodeModel<FileProperties>[];
};

export const MultipleDragPreview: FC<Props> = (props) => {
	return (
		<Badge
			sx={{
				"& .MuiBadge-badge": {
					border: "solid 2px #fff",
				},
			}}
			color="error"
			badgeContent={props.dragSources.length}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
		>
			<div
				style={{
					alignItems: "flex-start",
					backgroundColor: "#1967d2",
					borderRadius: "4px",
					boxShadow:
						"0 12px 24px -6px rgba(0, 0, 0, 0.25); 0 0 0 1px rgba(0, 0, 0, 0.08)",
					display: "flex",
					flexDirection: "column",
					gap: "4px",
					padding: "8px",
				}}
				data-testid="custom-drag-preview"
			>
				{props.dragSources.map((node) => (
					<div
						style={{
							alignItems: "center",
							color: "#fff",
							display: "inline-grid",
							fontSize: "0.75rem",
							gap: "8px",
							gridTemplateColumns: "auto auto",
						}}
					>
						<div
							style={{
								alignItems: "center",
								display: "flex",
							}}
						>
							<TypeIcon
								droppable={node.droppable || false}
								fileType={node?.data?.fileType}
							/>
						</div>
						<div
							style={{
								alignItems: "center",
								display: "flex",
							}}
						>
							{node.text}
						</div>
					</div>
				))}
			</div>
		</Badge>
	);
};
